import {Button, Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {EmptySearchState} from 'presentation/components/EmptySearchState';
import {ChatRoomsEnum} from 'presentation/constants/chatRoomEnum';
import {useCallChatRoom} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {ExamProfessionalSelectionNotFoundStateProps} from './types';
import {Loading} from 'presentation/components/Loading/Loading';

const {emptyDescription, callToChat, clearFilters} = translations['pt-br'].commons;
const {emptySearchState, notFoundModal} =
	translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function ExamProfessionalSelectionNotFoundState({
	showClearFilterButton,
	handleClearShiftAndSearch,
	dataTagId,
}: ExamProfessionalSelectionNotFoundStateProps) {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const title = showClearFilterButton ? notFoundModal.emptyTitle : emptySearchState.emptyTitle;

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.EXAMS);
	};

	return (
		<Fragment>
			<EmptySearchState
				dataTagId={dataTagId}
				title={title}
				description={emptyDescription}
				imageV2>
				<Stack gap={2}>
					<Button
						variant={'contained'}
						size="large"
						data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
						onClick={handleCallChatRoom}
						disabled={callChatRoomIsLoading}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}>
						{callToChat}
					</Button>

					{showClearFilterButton ? (
						<Button variant="outlined" size="large" onClick={handleClearShiftAndSearch}>
							{clearFilters}
						</Button>
					) : null}
				</Stack>
			</EmptySearchState>
		</Fragment>
	);
}
